import Api from '../Api.js';
import Confirm from '../components/Confirm.js';
import DOMPurify from "dompurify";

/**
 * FileImport
 */
export default class FileImport {

    constructor($container, options) {
        this.$container = $container;
        this.options = $.extend({
            url: '', //API URL to post the data
            title: '', //name of component e.g. Import <<GUIDE>>
            formTpl: '', //form for file import
            datalist: '', // component to be reloaded after imported
            type: ''
        }, options);
    }

    init() {
        const self = this;
        self.renderForm();
        self.setEvents();
    }

    renderForm() {
        const self = this;
        Api.getTpl(this.options.formTpl).done(function (r) {
            const tpl = _.template(r);
            const content = tpl({
                item: {"title": self.options.title, "type": self.options.type}
            });
            self.$container.append(DOMPurify.sanitize(content));

        });
    }


    /**
     *  Set mouse events
     */
    setEvents() {
        const self = this;

        //open file explorer
        this.$container.off("click.patho").on("click.patho", '.import', function () {
            self.$container.find('.file').click();
            return false;
        });

        //Save
        this.$container.off("change.paths").on("change.paths", '.file', function () {
            const input = $(this);
            if (input[0].files.length > 0) {
                const data = new FormData();
                data.append('filedata', input[0].files[0]);
                data.append('app', $('[data-app]').data('app'));

                FileImport.startProgress();

                Api.send(self.options.url, data, 'post', 'formdata').done(function (results) {
                    if (self.options.datalist.reload) {
                        // when data is rendered with Table class
                        self.options.datalist.reload();
                    } else {
                        //raise the event in the view class
                        $(self.options.datalist).trigger('reload');
                    }
                    input.parents('form').trigger('reset');
                    FileImport.endProgress(results);
                }).fail(function (xhr, err) {
                    FileImport.endProgress(`<div class="aero-error-box"><ul><li>${xhr.responseText}</li></ul></div>`);
                    input.parents('form').trigger('reset');
                });
            }
        });
    }

    static startProgress() {
        const html = `<div class="progress">
                <div class="progress-bar progress-bar-striped progress-bar-animated" style="width: 100%"></div>
            </div>`;
        Confirm({
            ok: Lang.ok,
            cancel: '',
            title: Lang.import,
            msg: html,
            classes: 'import-progress',
            onConfirm: function () {
            }
        });
        $('.import-progress .btn').addClass('hidden');
    }

    static endProgress(msg) {
        $('.import-progress .btn').removeClass('hidden');
        $('.import-progress .modal-body').empty().append(DOMPurify.sanitize(msg));
    }
}
